<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2020-10-09 09:26:15
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2023-11-20 14:42:45
 * @FilePath: /platform/src/views/flow/help/ScriptList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :page-result="pageBean"
      :selection="true"
      :default-sorter="[{ direction: 'DESC', property: 'update_time_' }]"
      quick-search-props="name,category"
      ref="ecoTable"
      :show-export="false"
      :show-custom-column="false"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" type="primary" @click="handleOpen('添加常用脚本')">添加</el-button>
          <fe-delete-button :url="formDeleteUrl()" class="marginLeft16" :htTable="$refs.ecoTable">删除</fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="name" label="名称" :show-overflow-tooltip="true" :sortable="true">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleOpen('编辑常用脚本', scope.row)">{{ scope.row.name }}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="category" :show-overflow-tooltip="true" label="脚本类型">
          <template slot-scope="scope">
            <span>
              <el-tag type="info">{{ scope.row.category }}</el-tag>
            </span>
          </template>
        </eco-table-column>
        <eco-table-column prop="memo" width="400" label="备注" :show-overflow-tooltip="true" :sortable="true" />
      </template>
    </eco-table>

    <!-- 脚本编辑 -->
    <script-edit :editData="editData" @loadList="loadList" ref="scriptEdit"></script-edit>
  </div>
</template>

<script>
import flow from '@/api/flow.js'
const scriptEdit = () => import('@/views/flow/help/ScriptEdit.vue')
export default {
  components: {
    scriptEdit
  },
  data() {
    return {
      pageBean: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      editData: {},
      data: []
    }
  },
  methods: {
    handleOpen(param, row) {
      this.editData.title = param
      this.editData.data = row
      this.$refs.scriptEdit.handleOpen()
    },
    formDeleteUrl() {
      return window.context.portal + '/runtime/script/v1/remove?ids'
    },
    loadList() {
      this.$refs.ecoTable.load()
    },
    loadData(param, cb) {
      if (!param) {
        this.pageBean.total = 0
        param = { pageBean: '' }
        param.pageBean = this.pageBean
      }
      flow
        .getScriptList(param)
        .then((resp) => {
          this.data = resp.data.rows
          this.pageBean = {
            page: resp.data.page,
            pageSize: resp.data.pageSize,
            total: resp.data.total
          }
        })
        .finally(() => cb())
    }
  }
}
</script>
